import React from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import Chart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';

const ReferralConversionRate = ({dashBoardCount}: any): any => {
  const options: any = {
    chart: {
      height: 700,
      // type: 'donut',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Active/In Active Users`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    labels: ['In Active', 'Active'],
    legend: {
      position: 'bottom', // This places the legend at the bottom
      horizontalAlign: 'center', // Centers the legend items
      floating: false, // Set to false to avoid floating over the chart
    },
  };
  return (
    <Col xxl={12} className="order-last">
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1 text-start">
            Referral Conversion Rate
          </h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xxl={12}>
              <Chart
                options={options}
                series={
                  dashBoardCount !== undefined
                    ? [
                        dashBoardCount?.not_converted_to_member,
                        dashBoardCount?.converted_to_member,
                      ]
                    : []
                }
                type="donut"
                height="450"
                className="apex-charts apex-charts-dashboard"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default ReferralConversionRate;
